const calculate = {
  calculate: {
    title: "为他人计算",
    subtitle: "为朋友、家人或客户生成紫微斗数星图",
    savedProfiles: "已保存的档案",
    noProfiles: "暂无保存的档案",
    newCalculation: "新建计算",
    enterDetails: "输入个人详细信息以生成其紫微斗数星图",
    generateChart: "生成星图",
    aboutZiWei: "关于紫微斗数",
    whatIsZiWei: "什么是紫微斗数？",
    requiredInfo: "所需信息",
    interpretation: "解读",
    whatIsDescription: "紫微斗数是中国古代占星术系统，根据一个人的出生日期和时间创建星图。它分析天体的位置，提供关于性格、人际关系、事业和人生道路的见解。",
    requiredInfoDescription: "要创建准确的紫微斗数星图，您需要准确的出生日期、时间和地点。信息越精确，星图就越准确。",
    interpretationDescription: "星图分析提供关于生活各个方面的见解，包括事业、人际关系、健康和个人发展。解读结合了传统智慧和现代心理学理解。"
  },

  form: {
    name: "姓名",
    relationship: "关系",
    gender: "性别",
    birthDate: "出生日期",
    birthTime: "出生时间",
    birthPlace: "出生地点",
    saveProfile: "保存档案",
    selectGender: "选择性别",
    male: "男",
    female: "女",
    namePlaceholder: "姓名",
    relationshipPlaceholder: "例如：朋友、客户、父亲",
    birthPlacePlaceholder: "城市，国家",
    yourNamePlaceholder: "您的姓名",
    theirNamePlaceholder: "他们的姓名",
    cancel: "取消",
    createSelfProfile: "创建我的档案",
    createOtherProfile: "创建档案",
    selectedDate: "选择日期",
    selectTime: "选择时间",
    dateFormatHint: "请按照日/月/年格式输入日期（例如：31/12/1990）",
    invalidDateFormat: "日期格式无效。请使用日/月/年格式",
    dontRememberBirthTime: "我不记得出生时间",
    submitting: "创建中...",
    email: "电子邮件",
    emailPlaceholder: "your@email.com",
  },
};

export default calculate;